"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const offer_notification_subscription_form_1 = require("@src/components/modules/forms/offer-notification-subscription-form");
const loading_wrapper_1 = __importDefault(require("@src/components/modules/global/loading-wrapper"));
const Api = __importStar(require("@src/api"));
function OfferNotificationSubscriptionSection() {
    const [subscription, setSubscription] = react_1.default.useState(null);
    const [isLoading, setIsLoading] = react_1.default.useState(true);
    const initialize = async () => {
        setIsLoading(true);
        try {
            const fetchedSubscription = await Api.OfferNotificationSubscription.getSubscription();
            setSubscription(fetchedSubscription);
        }
        catch (err) {
            setSubscription(null);
        }
        finally {
            setIsLoading(false);
        }
    };
    react_1.default.useEffect(() => {
        initialize();
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsx)(loading_wrapper_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(offer_notification_subscription_form_1.OfferNotificationSubscriptionForm, { subscription: subscription, showEmailField: false, onSubmit: initialize, onDelete: initialize }) }) }));
}
exports.default = OfferNotificationSubscriptionSection;
